import { render, staticRenderFns } from "./FiltersMyResources.vue?vue&type=template&id=395f4553&scoped=true&"
import script from "./FiltersMyResources.vue?vue&type=script&lang=js&"
export * from "./FiltersMyResources.vue?vue&type=script&lang=js&"
import style0 from "./FiltersMyResources.vue?vue&type=style&index=0&id=395f4553&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395f4553",
  null
  
)

export default component.exports